<template>
	<div>
		<div class="hide">
			<v-btn type="" class="primary p-2" @click="createPdf()">Save</v-btn>
			<v-btn type="" class="primary p-2" @click="print()">Print</v-btn>
		</div>
		<div id="page">
			
			<table>
				<thead><tr><td>
					<div class="header-space">&nbsp;</div>
				</td></tr></thead>
				<tbody><tr><td>

					<v-container id="print" class="py-0 my-0">
						<v-row class="">
							<v-col class="head" cols="4"></v-col>
							<v-col class="head" cols="8"></v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-row v-for="num in 6" :key="num" class="adjust">
									<v-col cols="9" class="pb-0">
										<h3>option #{{num}}</h3>
										<ul>
											<li >
												<p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem unde reiciendis ullam necessitatibus ut eaque neque</p>
											</li>
											<li >
												<p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem unde reiciendis ullam necessitatibus ut eaque neque</p>
											</li>
											<li >
												<p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem unde reiciendis ullam necessitatibus ut eaque neque</p>
											</li>
										</ul>
									</v-col>
									<v-col cols="3">
										price : 2344
									</v-col>
								</v-row>
							</v-col>
						</v-row>
						<footer class="footer">
							<h2 class="text-capitalize ">thank you very much for your business!</h2>
							<h5>801-221-5678 / SomeWebSite.com</h5>
						</footer>
					</v-container>

				</td></tr></tbody>
				<tfoot><tr><td>
					<div class="footer-space">&nbsp;</div>
				</td></tr></tfoot>
			</table>

			
		</div>
	</div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
	name: 'Dev',
	components: {

	},
	data(){
		return {

		}
	},
	watch: {

	},
	methods: {
		createPdf(){
			window.html2canvas = html2canvas
			const el = document.querySelector("#print")

			html2canvas(el).then(canvas => {
				let image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
				document.body.appendChild(canvas)
      	// window.location.href = image
      })
		},
		print(){
			window.print()
		}
	}

}
</script>
<style type="text/css" scoped>
.header, .header-space,
.footer, .footer-space {
	height: 70px;
}

.header {
	/*position: fixed;*/
	top: 0;
}
.footer {
	/*position: fixed;*/
	text-align: center;
	padding: 0;
	margin: 0 auto;
	bottom: 0;
	width: 100%;
}
@media print {
	* {
		border: 1px solid red;
	}
	@page {
		margin: 0;
		padding: 0;
		margin-top: 0mm;
		padding-top: 0mm;
		size: letter portrait;
		height: 11in;
		width: 8.5in;
	}
	#print{
		width: 100%;
	}
	.footer {
		position: fixed;
		bottom: 0;
	}
	.hide {
		display: none;
	}
}
</style>
